import { render, staticRenderFns } from "./DesignsAlgolia.vue?vue&type=template&id=e4d2b066&scoped=true"
import script from "./DesignsAlgolia.vue?vue&type=script&lang=js"
export * from "./DesignsAlgolia.vue?vue&type=script&lang=js"
import style0 from "./DesignsAlgolia.vue?vue&type=style&index=0&id=e4d2b066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d2b066",
  null
  
)

export default component.exports